
(function(){
  if (window.__pgBundlesInit) return; window.__pgBundlesInit = true;

  var CDN = 'https://cdn.myshopage.com/';
  var A = {
    single: CDN + '3cedfc5f-f744-442f-d881-8bc5ba07cb00/w200.jpeg',
    blue:   CDN + '6b260f48-0934-4588-e6a8-4c444a9bed00/w200.jpeg',
    badge90: CDN + '68dc8267-b959-43b4-9066-5aafbf84ba00.png',
    pay: ['7b4e2e96-606c-4ab1-07ee-b7f9654d2200.jpg','09d31e6e-8ed3-4c5f-3f60-7a8e1a78b100.jpg',
          'bc2d277c-b322-4fcc-661e-ddd1ef72c400.jpg','4f369144-595b-4b87-7588-4ba680a98f00.jpg',
          '6fed926e-cf4e-4e2f-d855-7c3d46ca5600.jpg','066aa7cc-33b7-4d5c-6434-02d3bfc4fa00.jpg',
          '48f526bb-90b9-4a74-fe9b-ee0786647500.jpg'].map(function(x){return CDN + x;})
  };
  // Add to Cart destinations — Shopify cart permalinks (VARIANT_ID:QUANTITY).
  var LINKS = {
    single: 'https://primegradelabs.com/cart/67639496835257:1',
    blue:   'https://primegradelabs.com/cart/67639496868025:1'
  };

  var BUNDLES = [
    {k:'single', img:A.single, name:'Sakerplus® Multi-function Universal Socket Wrench Tool', desc:'Adjustable sleeve + extension rod / 1 Set', price:22.99, was:45.99, best:false},
    {k:'blue',   img:A.blue,   name:'Sakerplus® Multi-function Universal Socket Wrench Tool', desc:'Adjustable sleeve + extension rod + Blue Handle / 1 Set', price:36.99, was:73.99, best:true}
  ];
  var selected = 'blue';
  function get(k){ for(var i=0;i<BUNDLES.length;i++) if(BUNDLES[i].k===k) return BUNDLES[i]; return BUNDLES[0]; }
  function m(n){ return '$' + n.toFixed(2); }

  var CSS = ''
  + '.pg-bundles{max-width:680px;margin:28px auto 8px;padding:0 16px;font-family:inherit;box-sizing:border-box}'
  + '.pg-bundles *{box-sizing:border-box}'
  + '.pg-head{text-align:center;margin:0 0 18px}'
  + '.pg-model{font-size:22px;font-weight:800;color:#111;margin:0 0 6px}'
  + '.pg-social{display:flex;align-items:center;justify-content:center;gap:10px;font-size:15px;color:#6b7280;font-weight:600}'
  + '.pg-stars{color:#f5b301;font-size:18px;letter-spacing:1px}'
  + '.pg-title{font-size:26px;font-weight:800;text-align:left;margin:0 0 16px;color:#111}'
  + '.pg-title:after{content:"";display:block;height:1px;background:#e5e7eb;margin-top:10px}'
  + '.pg-card{position:relative;display:flex;align-items:center;gap:12px;border:1px solid #e3e6ea;border-radius:10px;padding:14px 14px 14px 44px;margin-bottom:14px;cursor:pointer;transition:border-color .15s,background .15s;background:#fff}'
  + '.pg-card.pg-selected{border-color:#2f6fed;background:#f3f7ff;box-shadow:0 0 0 1px #2f6fed inset}'
  + '.pg-radio{position:absolute;left:14px;top:50%;transform:translateY(-50%);width:20px;height:20px;border:2px solid #c3c9d2;border-radius:50%}'
  + '.pg-card.pg-selected .pg-radio{border-color:#1f8f46}'
  + '.pg-card.pg-selected .pg-radio:after{content:"";position:absolute;left:3px;top:3px;width:10px;height:10px;border-radius:50%;background:#1f8f46}'
  + '.pg-img{width:92px;height:92px;object-fit:contain;flex:none;background:#fff}'
  + '.pg-info{flex:1;min-width:0}'
  + '.pg-name{font-weight:700;font-size:15px;line-height:1.25;color:#111}'
  + '.pg-desc{font-size:13px;color:#6b7280;margin:3px 0 6px}'
  + '.pg-price{display:flex;align-items:baseline;gap:8px}'
  + '.pg-now{color:#e23744;font-weight:800;font-size:19px}'
  + '.pg-was{color:#9ca3af;text-decoration:line-through;font-size:14px}'
  + '.pg-off{display:inline-block;margin-top:6px;background:#fde8ea;color:#e23744;font-weight:700;font-size:12px;padding:3px 10px;border-radius:999px}'
  + '.pg-badge-best{position:absolute;top:-10px;left:36px;background:#c0392b;color:#fff;font-size:12px;font-weight:700;padding:3px 10px;border-radius:5px}'
  + '.pg-atc{display:block;width:100%;text-align:center;background:#00af57;color:#fff;font-weight:700;font-size:18px;padding:15px;border:0;border-radius:6px;cursor:pointer;text-decoration:none;margin:4px 0 16px}'
  + '.pg-atc:hover{background:#049c4e}'
  + '.pg-pay-title{display:flex;align-items:center;gap:12px;color:#8a909a;font-size:12px;letter-spacing:.06em;margin:4px 0 12px}'
  + '.pg-pay-title:before,.pg-pay-title:after{content:"";flex:1;height:1px;background:#e5e7eb}'
  + '.pg-pay{display:flex;flex-wrap:wrap;justify-content:center;gap:8px;margin-bottom:26px}'
  + '.pg-pay img{height:30px;width:auto;border:1px solid #eef0f3;border-radius:6px;background:#fff;padding:2px}'
  + '.pg-guar{display:flex;align-items:flex-start;gap:16px;border-top:1px solid #eef0f3;padding-top:20px;margin-bottom:8px}'
  + '.pg-guar-badge{width:96px;height:auto;flex:none}'
  + '.pg-guar-h{font-size:20px;font-weight:800;color:#111;margin-bottom:6px}'
  + '.pg-guar-t{font-size:14px;color:#4b5563;line-height:1.5;margin:0}'
  + '@media(max-width:520px){.pg-title{text-align:center}.pg-img{width:76px;height:76px}.pg-now{font-size:17px}.pg-guar-badge{width:72px}.pg-guar-h{font-size:17px}}';

  function cardsHtml(){
    return BUNDLES.map(function(b){
      return '<label class="pg-card'+(b.k===selected?' pg-selected':'')+'" data-k="'+b.k+'">'
        + (b.best?'<span class="pg-badge-best">Best Seller</span>':'')
        + '<span class="pg-radio"></span>'
        + '<img class="pg-img" src="'+b.img+'" alt="">'
        + '<div class="pg-info"><div class="pg-name">'+b.name+'</div>'
        + '<div class="pg-desc">'+b.desc+'</div>'
        + '<div class="pg-price"><span class="pg-now">'+m(b.price)+'</span><span class="pg-was">'+m(b.was)+'</span></div>'
        + '<span class="pg-off">50% OFF</span></div></label>';
    }).join('');
  }

  function build(){
    var wrap = document.createElement('div');
    wrap.className = 'pg-bundles'; wrap.id = 'pgBundles';
    var pays = A.pay.map(function(u){return '<img src="'+u+'" alt="">';}).join('');
    wrap.innerHTML =
        '<div class="pg-head"><div class="pg-model">New &amp; Improved 2026 Model</div>'
      + '<div class="pg-social"><span class="pg-stars">★★★★★</span><span>100,000+ Happy Customers</span></div></div>'
      + '<h2 class="pg-title">Choose Your Bundles</h2>'
      + '<div class="pg-cards">'+cardsHtml()+'</div>'
      + '<a href="#" class="pg-atc" id="pgAtc">Add to cart</a>'
      + '<div class="pg-pay-title"><span>SECURE PAYMENT GUARANTEED</span></div>'
      + '<div class="pg-pay">'+pays+'</div>'
      + '<div class="pg-guar"><img class="pg-guar-badge" src="'+A.badge90+'" alt="90 Day Money Back Guarantee">'
      + '<div><div class="pg-guar-h">90 Day Money Back Guarantee</div>'
      + '<p class="pg-guar-t">Ensuring that our customers are 100% happy with every product they purchase from us is critically important to us. If you are not 100% satisfied with your purchase, you can return it for a full refund within 90 days of purchase.</p></div></div>';

    wrap.addEventListener('click', function(e){
      var card = e.target.closest ? e.target.closest('.pg-card') : null;
      if(card){ selected = card.getAttribute('data-k');
        wrap.querySelectorAll('.pg-card').forEach(function(c){c.classList.toggle('pg-selected', c===card);});
        e.preventDefault();
      }
    });
    wrap.querySelector('#pgAtc').addEventListener('click', function(e){
      e.preventDefault();
      var url = LINKS[selected];
      if(!url) return;
      if(window.PrimeGradeFunnelAds) window.PrimeGradeFunnelAds.beginCheckout(url);
      else window.location.href = url;
    });
    return wrap;
  }

  function insert(){
    if(document.getElementById('pgBundles')) return true;
    var faqH = [].slice.call(document.querySelectorAll('h1,h2,h3,h4,div,p,span')).find(function(e){
      var t=(e.textContent||'').trim();
      return /^frequently asked questions$/i.test(t) || (/frequently asked questions/i.test(t) && t.length < 40 && e.children.length <= 1);
    });
    if(!faqH || !faqH.parentElement) return false;
    faqH.parentElement.insertBefore(build(), faqH);
    return true;
  }

  function addStyle(){ if(document.getElementById('pgBundlesCss'))return; var s=document.createElement('style'); s.id='pgBundlesCss'; s.textContent=CSS; document.head.appendChild(s); }

  function scrollToBundles(){ var b=document.getElementById('pgBundles'); if(b) b.scrollIntoView({behavior:'auto', block:'start'}); }
  function wireStickyCTA(){
    var button=document.querySelector('#swtProductStickyCta button');
    if(!button || button.__pgStickyBound) return;
    button.__pgStickyBound=true;
    button.addEventListener('click', function(e){ e.preventDefault(); scrollToBundles(); }, true);
  }
  function isBuyText(t){ t=(t||'').trim(); return t.length<40 && /\b(buy\s*now|get\s*50%?\s*off|order\s*now)\b/i.test(t); }

  // All "BUY NOW / GET 50% OFF" CTAs scroll to the bundle section instead of navigating.
  function rewireCTAs(){
    if(!document.getElementById('pgBundles')) return;
    [].slice.call(document.querySelectorAll('a,button,div,span')).forEach(function(el){
      if(el.closest && el.closest('#pgBundles')) return;
      if(!isBuyText(el.textContent) || el.children.length>3) return;
      var a = el.closest && el.closest('a[href]');
      if(a){ try{ a.removeAttribute('href'); a.style.cursor='pointer'; }catch(_){ } } // so navfix ignores it
      if(!el.__pgcta){ el.__pgcta=true;
        el.addEventListener('click', function(e){ e.preventDefault(); e.stopImmediatePropagation(); scrollToBundles(); }, true);
      }
    });
  }

  // Find the real sticky bottom CTA bar (bottom-anchored fixed/sticky bar containing a buy CTA).
  function findSticky(){
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var fb = document.querySelector('.floatBtn');
    if(fb){ var fp=getComputedStyle(fb).position; if(fp==='fixed'||fp==='sticky') return fb; }
    var cands=[].slice.call(document.querySelectorAll('div,a,button,section')).filter(function(e){
      var p=getComputedStyle(e).position; if(p!=='fixed' && p!=='sticky') return false;
      var r=e.getBoundingClientRect();
      if(r.height<24 || r.height>300) return false;
      if(Math.abs(r.bottom - vh) > 80) return false;            // anchored to the bottom of the viewport
      return /buy\s*now|get\s*50%?\s*off|order\s*now/i.test((e.textContent||''));
    });
    return cands[0] || null;
  }
  var _sticky=null;
  function getSticky(){ if(_sticky && document.contains(_sticky)) return _sticky; _sticky=findSticky(); return _sticky; }
  function hideSticky(s){ s.style.setProperty('display','none','important'); }
  function showSticky(s){ s.style.removeProperty('display'); s.style.removeProperty('opacity'); s.style.removeProperty('pointer-events'); }
  function syncSticky(){
    var bundle=document.getElementById('pgBundles'); if(!bundle) return;
    var s=getSticky(); if(!s) return;
    var r=bundle.getBoundingClientRect(); var vh=window.innerHeight||document.documentElement.clientHeight;
    var visible = r.top < vh*0.9 && r.bottom > vh*0.1; // bundle meaningfully on screen
    if(visible) hideSticky(s); else showSticky(s);
  }

  function go(){ addStyle(); insert(); wireStickyCTA(); rewireCTAs(); syncSticky(); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',go); else go();
  window.addEventListener('scroll', syncSticky, {passive:true});
  window.addEventListener('resize', syncSticky, {passive:true});
  setInterval(function(){ addStyle(); insert(); wireStickyCTA(); rewireCTAs(); syncSticky(); }, 400); // keep in sync across app re-renders
  try{ var moT; var mo=new MutationObserver(function(){ clearTimeout(moT); moT=setTimeout(function(){ rewireCTAs(); syncSticky(); }, 150); });
       mo.observe(document.body,{childList:true,subtree:true}); setTimeout(function(){ mo.disconnect(); }, 30000); }catch(_){ }
})();
